/* eslint no-unused-vars: 0 */
/* eslint no-shadow: 0 */

import React from 'react';
import PropTypes  from 'prop-types';
import MapGL, { Layer, Feature, Marker, Popup } from 'react-mapbox-gl';
// import CityPin from './city-pin';
// import CityInfo from './city-info';
// import ControlPanel from './control-panel';
// import CITIES from './cities.json';

const MapBox = MapGL({
  accessToken: 'pk.eyJ1IjoiYWhhcm9ud2Fzc2VybWFuIiwiYSI6ImNpenlsN2xvdTAwYmYyd215cDY0bjV5YXEifQ.NJxXuAzP3xJIClft9z5LKA'
});

const navStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  padding: '10px'
};

class Map extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      viewport: {
        latitude: 40.70753927163922,
        longitude: -73.92549139171183,
        zoom: 9.5,
        bearing: 0,
        pitch: 0,
        width: 400,
        height: 400,
      },
      popupInfo: null
    };
  }

  componentWillMount() {
    this.setState({
      visits: this.props.visits
    });
  }

  componentDidMount() {
    window.addEventListener('resize', this._resize);
    this._resize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._resize);
  }

  _resize = () => {
    this.setState({
      viewport: {
        ...this.state.viewport
      }
    });
  };

  _updateViewport = (viewport) => {
    this.setState({viewport});
  }

  // _renderVisitMarker = (visit, index) => {
  //   return (
  //     <Marker key={`marker-${index}`}
  //       longitude={visit.lon}
  //       latitude={visit.lat} >
  //       <CityPin size={20} onClick={() => this.setState({popupInfo: visit})} />
  //     </Marker>
  //   );
  // }
  //
  // _renderPopup() {
  //   const {popupInfo} = this.state;
  //
  //   return popupInfo && (
  //     <Popup tipSize={5}
  //       anchor="top"
  //       longitude={popupInfo.lon}
  //       latitude={popupInfo.lat}
  //       onClose={() => this.setState({popupInfo: null})} >
  //       <CityInfo info={popupInfo} />
  //     </Popup>
  //   );
  // }

  onToggleHover() {
    return true;
  }

  markerClick() {
    return true;
  }

  render() {
    const {viewport} = this.state;
    return (
      <MapBox
        style="mapbox://styles/aharonwasserman/cj8yyqwv5if2l2rphupi0mkee"
        containerStyle={{
          height: '100vh',
          width: '100vw'
        }}
        zoom={[11]}
        center={[ this.context.user.lon, this.context.user.lat ]}>
        <Layer
          type="symbol"
          id="marker"
          layout={{ 'icon-image': 'harbor-15' }}
          >
          {
            Object.keys(this.state.visits).map((visitK, index) => (
              <Feature
                key={visitK}
                onMouseEnter={this.onToggleHover.bind(this, 'pointer')}
                onMouseLeave={this.onToggleHover.bind(this, '')}
                onClick={this.markerClick.bind(this, this.state.visits[visitK])}
                coordinates={[this.state.visits[visitK].lon, this.state.visits[visitK].lat]}
              />
            ))
          }
        </Layer>
      </MapBox>
    );
  }
}

Map.contextTypes = {
  user: PropTypes.object
};

Map.propTypes = {
  width: PropTypes.any,
  height: PropTypes.any,
  children: PropTypes.any,
  containerComponent: PropTypes.any,
  visits: PropTypes.any
};

export default Map;



// WEBPACK FOOTER //
// ./client/components/Map/index.js